/**
 * Schema.org JSON-LD helpers — emit structured data that Google uses
 * to show rich snippets (title, author, date, thumbnail) in search results.
 *
 * Reference: https://schema.org/Article
 */

const SITE_NAME = 'Intimate.pt';
const SITE_URL = process.env.REACT_APP_BACKEND_URL;

function baseOrg() {
  return {
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${SITE_URL}/og-image.png`
    }
  };
}

function articleBase({ url, title, description, image, datePublished, dateModified, authorName }) {
  return {
    '@context': 'https://schema.org',
    mainEntityOfPage: { '@type': 'WebPage', '@id': url },
    headline: title,
    description: description || '',
    image: image ? [image] : [`${SITE_URL}/og-image.png`],
    datePublished: datePublished || undefined,
    dateModified: dateModified || datePublished || undefined,
    author: authorName
      ? { '@type': 'Person', name: authorName }
      : { '@type': 'Organization', name: SITE_NAME },
    publisher: baseOrg(),
    inLanguage: 'pt-PT'
  };
}

export function storyJsonLd(story) {
  if (!story) return null;
  const rating = Number(story.rating);
  const ratingCount = Number(story.rating_count);
  return {
    ...articleBase({
      url: `${SITE_URL}/story/${story.slug || story.id}`,
      title: story.title,
      description: story.synopsis || story.excerpt,
      image: story.cover_image,
      datePublished: story.created_at,
      dateModified: story.updated_at,
      authorName: story.author_name
    }),
    '@type': 'Article',
    articleSection: (story.categories && story.categories[0]) || 'Contos',
    keywords: Array.isArray(story.tags) ? story.tags.join(', ') : undefined,
    wordCount: story.word_count || undefined,
    timeRequired: story.reading_time ? `PT${story.reading_time}M` : undefined,
    aggregateRating:
      rating > 0 && ratingCount > 0
        ? {
            '@type': 'AggregateRating',
            ratingValue: Number(rating.toFixed(1)),
            ratingCount,
            bestRating: 5,
            worstRating: 1
          }
        : undefined
  };
}

export function articleJsonLd(article) {
  if (!article) return null;
  return {
    ...articleBase({
      url: `${SITE_URL}/prazer/${article.slug || article.id}`,
      title: article.title,
      description: article.excerpt,
      image: article.cover_image,
      datePublished: article.created_at,
      dateModified: article.updated_at,
      authorName: article.author_name || SITE_NAME
    }),
    '@type': 'Article',
    articleSection: article.category_name || '+ Prazer',
    timeRequired: article.reading_time ? `PT${article.reading_time}M` : undefined
  };
}

export function confessionJsonLd(confession) {
  if (!confession) return null;
  return {
    ...articleBase({
      url: `${SITE_URL}/confessions/${confession.slug || confession.id}`,
      title: confession.title,
      description: confession.excerpt,
      image: null,
      datePublished: confession.published_at || confession.submitted_at,
      dateModified: confession.published_at || confession.submitted_at,
      authorName: confession.is_anonymous ? 'Anónimo' : confession.author_name
    }),
    '@type': 'BlogPosting',
    articleSection: confession.category || 'Confissões'
  };
}
